export default {"src":"/_next/static/media/0x6123B0049F904d730dB3C36a31167D9d4121fA6B.df0b729a.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};